import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SSTable from '../SSTable/SSTable';
import SSColumn from '../SSTable/SSColumn';

export default class TierTable extends Component {
  renderHeader = header => {
    const { data } = this.props;

    if (header !== data.primary_key) {
      return header;
    }

    return (
      <span>
        <span className="fa fa-key key" title="Primary Key" />
        {header}
      </span>
    );
  };

  /**
   * Renders the column value for the given row and column index.
   * @param {Object} row - The current row object.
   * @param {number} colIndex - The index of the column to render.
   * @returns {JSX.Element} A span element containing the value of the specified cell in the tier table.
   */
  renderCol(row, colIndex) {
    return <span>{row.row.columns[colIndex].value}</span>;
  }

  renderColumns = () => {
    const { data } = this.props;
    const result = data.headers.map((header, index) => {
      const head = this.renderHeader(header);
      const columnKey = `${header}-${index}`;

      return <SSColumn header={head} cell={row => this.renderCol(row, index)} key={columnKey} />;
    });

    return result;
  };

  render() {
    const { data, selected, onClick, onDoubleClick } = this.props;

    if (!data || !data.tier) {
      return null;
    }

    const rows = data.tier.data;
    const columns = this.renderColumns();

    return (
      <SSTable
        data={rows}
        rowHeight={50}
        rowsCount={rows.length - 1}
        onSelect={onClick}
        doubleClick={onDoubleClick}
        selected={selected}
        selectable
        zebra
      >
        {columns}
      </SSTable>
    );
  }
}

TierTable.propTypes = {
  data: PropTypes.object.isRequired,
  selected: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  onDoubleClick: PropTypes.func.isRequired,
};
